// Modules
import React from 'react'

// Routes
import Routes from './routes/Main'

// Components
import Page from 'components/layout/page/Page'

// Hooks
// import useLanguage from 'hooks/system/useLanguage'

// Styles
import './TermsOfService.scss'

// Page: Terms of service
function TermsOfService () {
	// Data
	// const { translate } = useLanguage('pages.termsOfService')

	// Render
	return (
		<Page
			isPublic
			name="terms-of-service">
			<Routes />
		</Page>
	)
}

// Export
export default TermsOfService
